<template>
<div id="itembank-form">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
        <li>
            <router-link :to="{path: '/'}">Home</router-link>
        </li>
        <li>
            <router-link :to="{path: '/voucher'}">Kode Voucer</router-link>
        </li>
        <li class="active">Create</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Tambah Voucher</h1>
    <!-- end page-header -->
    <div class="row">
        <div class="col-md-12">
            <div class="panel panel-inverse">
                <div class="panel-heading">
                    <h4 class="panel-title">Form Voucher</h4>
                </div>
                <div class="panel-body panel-form">
                    <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
                        <span class="close" data-dismiss="alert">&times;</span>
                        <strong>Terjadi kesalahan!</strong>
                        <ul>
                            <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
                        </ul>
                    </div>
                    <form class="" style="margin-top:20px; margin-left:20px;">
                        <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('channel') >= 0 }">
                            <label class="control-label">E Commerce Channel</label>
                            <div class="row">
                                <div class="col-md-7">
                                    <select class="form-control" v-model="form.channel_id">
                                        <option v-for="(item, i) in listChannel" :key="i" :value="item.id">{{ item.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('name') >= 0 }">
                            <label class="control-label">Product</label>
                            <div class="row" v-for="(item,i) in form.products" :key="i" style="padding-bottom:5px;">
                                <div class="col-md-6">
                                    <!-- <select v-model="form.products[i].product_id" class="form-control">
                                        <option v-for="(item, i) in productList" :key="i" :value="item.value">{{ item.text}}</option>
                                    </select> -->
                                    <model-select :options="productList"
                                                  v-model="form.products[i].product_id"
                                                  placeholder="Pilih Produk">
                                    </model-select>
                                </div>
                                <div class="col-md-1">
                                    <input class="form-control" type="number" min="1" style="height:100%;" v-model="form.products[i].amount" />
                                </div>
                                <div class="col-md-2">
                                    <button class="btn btn-success btn-md m-1" type="buttom" @click="pushProduct(i)" v-if="form.products.length >= 1 && i == form.products.length - 1"><i class="fa fa-plus"></i></button>
                                    <button class="btn btn-danger btn-md m-1" type="buttom" @click="form.products.splice(i, 1)" v-if="form.products.length > 1 && i != form.products.length - 1"><i class="fa fa-trash"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-8">
                                <button v-if="$route.query.id" type="button" class="btn btn-success btn-md" @click="save()">Simpan Perubahan</button>
                                <button v-else type="button" class="btn btn-success btn-md" @click="save()">Buat Voucher</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
</div>
</template>

  
<script>
import Spinner from '@/components/plugins/Spinner'
import SalesService from '@/services/sales.js'
import VoucherService from '@/services/voucher.js'
import FileService from '@/services/file.js'
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelSelect } from 'vue-search-select'
export default {
    name: 'content-article-form',
    components: {
        'app-spinner': Spinner,
        'model-select': ModelSelect
    },
    data: function () {
        return {
            isLoading: false,
            compiledContent: '',
            labelQuery: '',
            productList: [],
            listChannel: [],
            channelSelected: '',
            productSelected: '',
            form: {
                channel_id: null,
                products: [{
                    product_id: null,
                    amount: null
                }]
            },
            errors: []
        }
    },
    mounted: function () {
        this.getProdukList()
    },
    methods: {
        getProdukList: function () {
            var context = this
            var search = {
                query: 'PUBLISHED',
                by: 'status'
            }

            var pagination = {
                perPage: 1000,
                currentPage: 1,
                sortMode: 'ASC'
            }

            context.isLoading = true
            VoucherService.getListChannels(pagination, '', function (result) {
                context.listChannel = result.data
            })
            SalesService.getProdukList(pagination, search, function (result) {
                // context.produkList = []
                context.isLoading = false

                if (result.success) {
                    result.data.forEach(function (content) {
                        var row = {
                            text: content.title.toLowerCase(),
                            value: content.id
                        }
                        context.productList.push(row)
                    })
                    context.productList.sort((a, b) => {
                        if (a.text < b.text)
                            return -1;
                        if (a.text > b.text)
                            return 1;
                        return 0;
                    })
                } else {
                    alert('Terjadi kesalahan : ' + result.message)
                }
            })
        },
        downloadGeneratedFile: function (path) {
            var context = this
            FileService.download2(path, function (response) {
                console.log(response)
            })
            context.$router.push({
                path: '/voucher'
            })
            context.loading = false
        },
        save: function () {
            var context = this
            context.isLoading = true
            if (this.validateForm()) {
                VoucherService.generateVoucher(this.form, function (result) {
                    if (result.success) {
                        context.downloadGeneratedFile(result.data.directory)
                        alert('voucher berhasil di generate')
                    } else {
                        alert('Terjadi kesalahan: ' + result.message)
                    }
                })
            } else {
                context.isLoading = false
            }
        },
        pushProduct: function(ind) {
          // if(ind > 1) {
            if(this.form.products[ind].product_id == null || this.form.products[ind].product_id == '' ) {
              alert('lengkapi produk sebelumnya terlebih dahulu')
              return false
            }
            if(this.form.products[ind].amount == null || this.form.products[ind].amount == '' || this.form.products[ind].amount < 1) {
              alert('data tidak valid atau tidak boleh kosong')
              return false
            }
          // }
          this.form.products.push({product_id: null, amount: null})
        },
        validateForm: function () {
            this.errors = []
            if (!this.form.channel_id) this.errors.push('Channel wajib diisi')
            // if (!this.form.products[0].product_id) this.errors.push('Produk wajib diisi')
            for(var i = 0; i < this.form.products.length; i++){
              if(this.form.products[i].product_id == null || this.form.products[i].product_id == '') this.errors.push('Produk wajib diisi')
              if(this.form.products[i].amount == null || this.form.products[i].amount == '' || this.form.products[i].amount < 1) this.errors.push('Jumlah Kuota wajib diisi atau nilai tidak valid')
            }
            if (this.errors.length == 0) return true

            return false
        },
    }
}
</script>



// WEBPACK FOOTER //
// Form.vue?5dbdea5e